import { OnBaseDocumentData } from '../types/OnBaseDocumentData'

async function DownloadFailedDocument(doc: OnBaseDocumentData) {
  try {

    const baseURL = process.env.REACT_APP_ONBASE_SUPPORT_API_URL;
    const endURL = '/api/DownloadFailedDocument';

    const response = await fetch(
      baseURL + endURL,
      {
        headers: { 'Content-Type': 'application/json' },
        method: "POST",
        body: JSON.stringify(doc)
      }
    );

    if (response.ok) {

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      console.log(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = doc.documentName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } else {
      throw new Error('Error Downloading OnBase Document');
    }
  } catch (error) {
    console.error('Error Downloading OnBase Document:', error);
  }
};

export default DownloadFailedDocument;